import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { IconButton } from 'transfix-ui/components/IconButton'
import { ILoad } from 'apps/fleet-planner/types'
import { IDropdownOption } from 'components/forms'
import { EllipsisIcon, DeleteIcon, LinkIcon } from 'transfix-icons'
import { OverflowMenu, useOverflowToggle } from 'transfix-ui'

export const LoadActions = memo<{ load: ILoad }>(({ load }) => {
  const { isExternal } = load || {}
  const history = useHistory()
  const { clickOverflowTrigger, expanded, setExpanded } = useOverflowToggle()

  const deleteLoadOption = {
    label: 'Delete Load',
    itemComponent: (
      <div className='flex flex-row items-center'>
        <DeleteIcon size='large' />
        <span className='ml2'>Delete Load</span>
      </div>
    ),
    action: () => {
      if (load.id) history.push(`${history.location.pathname}/${load.id}/delete`)
    },
  }

  const shareLoadOption = {
    label: 'Share Load',
    itemComponent: (
      <div className='flex flex-row items-center'>
        <LinkIcon size='large' />
        <span className='ml2'>Share Load</span>
      </div>
    ),
    action: () => {
      if (load.id) history.push(`${history.location.pathname}/${load.id}/share`)
    },
  }

  const options: IDropdownOption[] = isExternal
    ? [shareLoadOption]
    : [shareLoadOption, deleteLoadOption]

  return (
    <OverflowMenu
      options={options}
      trigger={
        <IconButton
          color='tertiary'
          label='overflow-trigger'
          Icon={EllipsisIcon}
          onClick={clickOverflowTrigger}
          size='large'
        />
      }
      expanded={expanded}
      onExpanded={setExpanded}
      dropdownId='fleet-row-actions'
    />
  )
})
